import glamorous from "glamorous"

const Section = glamorous.section({
  padding: "10px 0px",
})

export default Section



// WEBPACK FOOTER //
// ./src/elements/Section.js